import {
  SYS_MSG_SUB_TYPE,
  SYS_MSG_TYPE,
  type MqttEnvelope,
  type SysMessageItem,
  type SysMsgData
} from '@/types/mqtt'

export function parseMqttPayload(payload: Buffer | Uint8Array): MqttEnvelope | null {
  try {
    const text = typeof payload === 'object' && 'toString' in payload
      ? payload.toString()
      : new TextDecoder().decode(payload)
    return JSON.parse(text) as MqttEnvelope
  } catch {
    return null
  }
}

export function isSysMessage(data?: SysMsgData): data is SysMsgData {
  if (!data) return false
  const { type, subType } = data
  return (
    (type === SYS_MSG_TYPE.PERSONAL || type === SYS_MSG_TYPE.BROADCAST) &&
    subType === SYS_MSG_SUB_TYPE.DEFAULT
  )
}

export function toSysMessageItem(data: SysMsgData): SysMessageItem {
  const attachment = data.attachment
  return {
    id: `${data.type}_${data.subType}_${data.msgId ?? 0}_${data.time ?? Date.now()}`,
    type: data.type,
    subType: data.subType,
    title: attachment?.title || data.fromUser?.name || '系统消息',
    content: data.content || '',
    image: attachment?.image,
    buttonText: attachment?.buttonText,
    attachment,
    time: data.time,
    receivedAt: data.time ?? Date.now(),
    read: false
  }
}
